import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityDocfile } from "../../entity/EntityDocfile";

export class DtoDocfilesGetReq extends EntityDocfile {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_docfile_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
